export enum EntitySearchSortDirectionEnum
{
    ascending = "ascending",
    descending = "descending",
}